import { metrics, type Meter } from "@opentelemetry/api";

/**
 * Returns a process-wide application meter.
 *
 * The server provider is installed from Next.js instrumentation. In client
 * bundles, or when metrics are disabled, OpenTelemetry supplies a no-op meter.
 * This keeps shared integration clients safe to import from either runtime.
 */
export function getApplicationMeter(serviceName: string): Meter {
  return metrics.getMeter(serviceName);
}
